export const unique = (arr) => [...new Set(arr)];

export const addUnique = (arr, item) => unique([...arr, item]);



// WEBPACK FOOTER //
// ./services/unique.js